(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  INIT                                                               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var dataEl = document.getElementById('pq-product-data');
    var questionsEl = document.getElementById('pq-questions-data');
    if (!dataEl || !questionsEl) return;

    var products, quizData;
    try {
      products = JSON.parse(dataEl.textContent);
      quizData = JSON.parse(questionsEl.textContent);
    } catch (e) {
      console.error('[PergolaQuiz] Invalid JSON', e);
      return;
    }
    if (!products.length || !quizData.questions || !quizData.questions.length) return;

    var QUESTIONS = quizData.questions;
    var UI = quizData.ui;

    var overlay = document.getElementById('pq-overlay');
    var modal   = document.getElementById('pq-modal');
    if (!overlay || !modal) return;

    var state = {
      step: 0,
      answers: {},
      products: products,
    };

    renderQuiz(modal, state, QUESTIONS, UI);
    bindOpen(overlay, modal, state, QUESTIONS);
    bindClose(overlay, modal);
  }

  /* ------------------------------------------------------------------ */
  /*  RENDER QUIZ HTML                                                   */
  /* ------------------------------------------------------------------ */
  function renderQuiz(modal, state, QUESTIONS, UI) {
    var html = '';

    // Close button
    html += '<button class="pq-close" data-pq-close aria-label="Schliessen">&times;</button>';

    // Progress
    html += '<div class="pq-progress">';
    html += '<div class="pq-progress__bar"><div class="pq-progress__fill" id="pq-fill" style="width:0%"></div></div>';
    html += '<div class="pq-progress__label" id="pq-progress-label"></div>';
    html += '</div>';

    // Question steps
    QUESTIONS.forEach(function (q, i) {
      html += '<div class="pq-step" data-pq-step="' + i + '"' + (i === 0 ? ' style="display:block"' : '') + '>';
      html += '<h3 class="pq-step__question">' + escapeHtml(q.question) + '</h3>';
      html += '<div class="pq-options">';
      q.options.forEach(function (opt) {
        html += '<button class="pq-option" data-pq-key="' + q.key + '" data-pq-value="' + opt.value + '">';
        html += '<span class="pq-option__icon">' + escapeHtml(opt.icon) + '</span>';
        html += '<span class="pq-option__text">';
        html += '<span class="pq-option__label">' + escapeHtml(opt.label) + '</span>';
        html += '<span class="pq-option__desc">' + escapeHtml(opt.desc) + '</span>';
        html += '</span></button>';
      });
      html += '</div></div>';
    });

    // Nav
    html += '<div class="pq-nav">';
    html += '<button class="pq-nav__back is-hidden" id="pq-back">&larr; ' + escapeHtml(UI.back_label) + '</button>';
    html += '<span></span>';
    html += '</div>';

    // Result
    html += '<div class="pq-result" id="pq-result"></div>';

    modal.innerHTML = html;

    // Store UI texts on modal for result rendering
    modal._quizUI = UI;
    modal._quizQuestions = QUESTIONS;

    // Bind option clicks
    modal.querySelectorAll('.pq-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.pqKey;
        var val = btn.dataset.pqValue;
        state.answers[key] = val;

        // Highlight selected
        btn.closest('.pq-options').querySelectorAll('.pq-option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        // Auto-advance after brief delay
        setTimeout(function () {
          if (state.step < QUESTIONS.length - 1) {
            goToStep(modal, state, state.step + 1, QUESTIONS);
          } else {
            showResult(modal, state, QUESTIONS, UI);
          }
        }, 250);
      });
    });

    // Back button
    document.getElementById('pq-back').addEventListener('click', function () {
      if (state.step > 0) {
        goToStep(modal, state, state.step - 1, QUESTIONS);
      }
    });

    updateProgress(state, QUESTIONS);
  }

  /* ------------------------------------------------------------------ */
  /*  NAVIGATION                                                         */
  /* ------------------------------------------------------------------ */
  function goToStep(modal, state, step, QUESTIONS) {
    state.step = step;

    modal.querySelectorAll('.pq-step').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('is-active');
    });

    var target = modal.querySelector('[data-pq-step="' + step + '"]');
    if (target) {
      target.style.display = 'block';
      target.offsetHeight; // force reflow
      target.classList.add('is-active');
    }

    // Hide result
    var result = document.getElementById('pq-result');
    if (result) {
      result.style.display = 'none';
      result.classList.remove('is-active');
    }

    // Restore previously selected option
    if (state.answers[QUESTIONS[step].key]) {
      var prev = state.answers[QUESTIONS[step].key];
      target.querySelectorAll('.pq-option').forEach(function (o) {
        o.classList.toggle('is-selected', o.dataset.pqValue === prev);
      });
    }

    // Back button visibility
    var backBtn = document.getElementById('pq-back');
    if (backBtn) {
      backBtn.classList.toggle('is-hidden', step === 0);
    }

    updateProgress(state, QUESTIONS);
  }

  function updateProgress(state, QUESTIONS) {
    var pct = ((state.step + 1) / QUESTIONS.length) * 100;
    var fill = document.getElementById('pq-fill');
    var label = document.getElementById('pq-progress-label');
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = 'Frage ' + (state.step + 1) + ' von ' + QUESTIONS.length;
  }

  /* ------------------------------------------------------------------ */
  /*  SCORING                                                            */
  /* ------------------------------------------------------------------ */
  function scoreProducts(answers, products, QUESTIONS) {
    return products.map(function (p) {
      var score = 0;
      var total = QUESTIONS.length;

      // Size
      if (answers.size) {
        var sizeKey = 'quiz_size_' + answers.size;
        if (p[sizeKey]) score++;
      }

      // Wind
      if (answers.wind && p.quiz_wind === answers.wind) score++;

      // Roof
      if (answers.roof && p.quiz_roof === answers.roof) score++;

      // Year round
      if (answers.yearRound !== undefined) {
        var wantsYearRound = answers.yearRound === 'true';
        if (p.quiz_year_round === wantsYearRound) score++;
      }

      // Budget
      if (answers.budget && p.quiz_budget === answers.budget) score++;

      return {
        product: p,
        score: score,
        pct: Math.round((score / total) * 100),
      };
    }).sort(function (a, b) {
      return b.score - a.score;
    });
  }

  /* ------------------------------------------------------------------ */
  /*  RESULT                                                             */
  /* ------------------------------------------------------------------ */
  function showResult(modal, state, QUESTIONS, UI) {
    // Hide all steps + nav
    modal.querySelectorAll('.pq-step').forEach(function (el) {
      el.style.display = 'none';
      el.classList.remove('is-active');
    });
    modal.querySelector('.pq-nav').style.display = 'none';
    modal.querySelector('.pq-progress').style.display = 'none';

    var ranked = scoreProducts(state.answers, state.products, QUESTIONS);
    var primary = ranked[0];
    var secondary = ranked.length > 1 ? ranked[1] : null;

    var resultEl = document.getElementById('pq-result');

    var html = '';
    html += '<h3 class="pq-result__title">' + escapeHtml(UI.result_title) + '</h3>';
    html += '<p class="pq-result__subtitle">' + escapeHtml(UI.result_subtitle) + '</p>';
    html += '<div class="pq-result__cards">';

    if (primary) {
      html += buildCard(primary, UI.primary_label, true, UI);
    }
    if (secondary) {
      html += buildCard(secondary, UI.secondary_label, false, UI);
    } else if (primary) {
      html += '<div class="pq-result__card-wrap">';
      html += '<div class="pq-result__card-label pq-result__card-label--secondary">' + escapeHtml(UI.secondary_label) + '</div>';
      html += '<div class="pq-card" style="display:flex;align-items:center;justify-content:center;min-height:200px;background:#f5f5f5;border:1px dashed #ccc;">';
      html += '<p style="color:#999;font-size:14px;text-align:center;padding:20px;">Weitere Modelle folgen in K\u00fcrze</p>';
      html += '</div></div>';
    }

    html += '</div>';
    html += '<button class="pq-result__restart" id="pq-restart">' + escapeHtml(UI.restart_text) + '</button>';

    resultEl.innerHTML = html;
    resultEl.style.display = 'block';
    resultEl.offsetHeight;
    resultEl.classList.add('is-active');

    // Restart
    document.getElementById('pq-restart').addEventListener('click', function () {
      state.step = 0;
      state.answers = {};
      modal.querySelector('.pq-nav').style.display = '';
      modal.querySelector('.pq-progress').style.display = '';
      resultEl.style.display = 'none';
      resultEl.classList.remove('is-active');

      modal.querySelectorAll('.pq-option.is-selected').forEach(function (o) {
        o.classList.remove('is-selected');
      });

      goToStep(modal, state, 0, QUESTIONS);
    });
  }

  function buildCard(item, label, isPrimary, UI) {
    var p = item.product;
    var cls = isPrimary ? 'pq-card--primary' : '';
    var labelCls = isPrimary ? 'pq-result__card-label--primary' : 'pq-result__card-label--secondary';

    var html = '<div class="pq-result__card-wrap">';
    html += '<div class="pq-result__card-label ' + labelCls + '">' + escapeHtml(label) + '</div>';
    html += '<a href="' + p.url + '" class="pq-card ' + cls + '">';

    if (p.image) {
      html += '<div class="pq-card__img"><img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>';
    }

    html += '<div class="pq-card__body">';
    html += '<div class="pq-card__score">' + item.pct + '% Match</div>';
    html += '<h4 class="pq-card__name">' + escapeHtml(p.title) + '</h4>';
    html += '<div class="pq-card__price">ab ' + p.price + '</div>';

    if (p.feature_1 || p.feature_2) {
      html += '<div class="pq-card__features">';
      if (p.feature_1) {
        html += '<div class="pq-card__feature">' + escapeHtml(p.feature_1) + '</div>';
      }
      if (p.feature_2) {
        html += '<div class="pq-card__feature">' + escapeHtml(p.feature_2) + '</div>';
      }
      html += '</div>';
    }

    html += '<span class="pq-card__btn">' + escapeHtml(UI.cta_text) + ' &rarr;</span>';
    html += '</div></a></div>';

    return html;
  }

  /* ------------------------------------------------------------------ */
  /*  MODAL OPEN / CLOSE                                                 */
  /* ------------------------------------------------------------------ */
  function bindOpen(overlay, modal, state, QUESTIONS) {
    document.querySelectorAll('[data-pq-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(overlay, modal, state, QUESTIONS);
      });
    });
  }

  function openModal(overlay, modal, state, QUESTIONS) {
    overlay.style.display = 'flex';
    overlay.offsetHeight;
    overlay.classList.add('is-active');
    document.documentElement.style.overflow = 'hidden';

    // Hide WhatsApp floating button
    var waBtn = document.getElementById('whatsapp-float');
    if (waBtn) waBtn.style.display = 'none';

    // Reset to step 0 if result was showing
    var resultEl = document.getElementById('pq-result');
    if (resultEl && resultEl.classList.contains('is-active')) {
      state.step = 0;
      state.answers = {};
      resultEl.style.display = 'none';
      resultEl.classList.remove('is-active');
      modal.querySelector('.pq-nav').style.display = '';
      modal.querySelector('.pq-progress').style.display = '';
      modal.querySelectorAll('.pq-option.is-selected').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      goToStep(modal, state, 0, QUESTIONS);
    }
  }

  function closeModal(overlay) {
    overlay.classList.remove('is-active');
    overlay.style.display = 'none';
    document.documentElement.style.overflow = '';

    // Show WhatsApp floating button again
    var waBtn = document.getElementById('whatsapp-float');
    if (waBtn) waBtn.style.display = '';
  }

  function bindClose(overlay, modal) {
    modal.querySelectorAll('[data-pq-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(overlay);
      });
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal(overlay);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        closeModal(overlay);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  HELPERS                                                            */
  /* ------------------------------------------------------------------ */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();
